import { FC } from 'react';

import { useReduxSelector } from 'shared/hooks/useReduxSelector';

import { InfoCost, InfoDescription } from './internal/components';
import { separateOfficeWithErrorSelector } from './internal/selectors/separateOfficeWithErrorSelector';

import * as styles from './InfoCardHeader.css';

export const InfoCardHeader: FC = () => {
  const separateOffice = useReduxSelector(separateOfficeWithErrorSelector);

  return (
    <div className={styles['container']}>
      <InfoDescription {...separateOffice} />
      <InfoCost {...separateOffice} />
    </div>
  );
};

InfoCardHeader.displayName = 'InfoCardHeader';
